import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CurrentUserStateService } from '../../../../shared/services/current-user-state.service';
import { ImpersonationService } from '../../../../shared/services/impersonation.service';
@Component({
    selector: 'app-profile-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.scss'],
})
export class ProfileAccountDetailsComponent implements OnInit {
    tabs = [{ label: 'Info' }, { label: 'Roles & Permissions' }];

    constructor(
        private currentUserStateService: CurrentUserStateService,
        private impersonationService: ImpersonationService
    ) {}

    ngOnInit() {
        let clientShortName = this.currentUserStateService.currentUser.clientShortName;
        if (clientShortName === 'LBA' && !this.impersonationService.isImpersonatingUser()) {
            return;
        } else {
            if (this.impersonationService.isImpersonatingClient()) {
                clientShortName = this.impersonationService.impersonateClient;
            }
        }
    }
}
